// extracted by mini-css-extract-plugin
export var loadingSpinner = "_22-0";